import { ImxRewardsMUI } from "@/components/icons";
import { Body, Box, MenuItem, ShimmerBox, type SxProps } from "@biom3/react";
import type React from "react";
import type { ReactNode } from "react";

interface AvatarBadgeProps {
  sx?: SxProps;
  onClick?: (e: React.MouseEvent) => void;
  children: ReactNode;
}

export const AvatarBadge: React.FC<AvatarBadgeProps> = ({
  sx,
  onClick,
  children,
}) => {
  return (
    <Box sx={sx} onClick={onClick}>
      <MenuItem.Badge
        variant="emphasis"
        badgeContent={
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "4px",
              px: "base.spacing.x1",
              py: "1px",
            }}
          >
            {children}
          </Box>
        }
      />
    </Box>
  );
};

interface SignInBadgeProps {
  sx?: SxProps;
  onClick: (callback?: () => Promise<void>) => void;
}

export const SignInBadge: React.FC<SignInBadgeProps> = ({ sx, onClick }) => {
  return (
    <AvatarBadge
      sx={sx}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Body
        size="medium"
        weight="bold"
        sx={{ fontSize: "14px", letterSpacing: "0.01em" }}
      >
        Sign In
      </Body>
    </AvatarBadge>
  );
};

interface GemsBadgeProps {
  sx?: SxProps;
  walletGems: number | string;
  onClick: (e: React.MouseEvent) => void;
  isLoading: boolean;
}

export const GemsBadge: React.FC<GemsBadgeProps> = ({
  sx,
  walletGems,
  isLoading,
  onClick,
}) => {
  return (
    <AvatarBadge sx={sx} onClick={onClick}>
      <ImxRewardsMUI
        variant="bold"
        sx={{ color: "black", w: "18px", h: "18px" }}
      />
      {isLoading ? (
        <ShimmerBox sx={{ width: "18px", height: "18px" }} />
      ) : (
        <Body
          size="medium"
          weight="bold"
          sx={{ fontSize: "16px", letterSpacing: "0.01em" }}
        >
          {walletGems}
        </Body>
      )}
    </AvatarBadge>
  );
};
